import { fireEvent } from '@testing-library/react';

/** Returns the column row element (by column id) within the given scope. */
export function getColumnRow(
  scope: HTMLElement,
  columnId: string,
): HTMLElement {
  const row = scope.querySelector<HTMLElement>(`[data-columnid="${columnId}"]`);
  if (!row) {
    throw new Error(`No column row found for column "${columnId}"`);
  }
  return row;
}

/** Returns the per-column visibility toggle button (by column id) within the scope. */
export function getColumnVisibilityToggle(
  scope: HTMLElement,
  columnId: string,
): HTMLElement {
  const toggle = getColumnRow(scope, columnId).querySelector<HTMLElement>(
    '[data-dt-children-name="ColumnSettingsShowHideColumn"]',
  );
  if (!toggle) {
    throw new Error(`No visibility toggle found for column "${columnId}"`);
  }
  return toggle;
}

/** Returns all per-column visibility toggle buttons within the scope, in list order. */
export function getAllVisibilityToggles(scope: HTMLElement): HTMLElement[] {
  return Array.from(
    scope.querySelectorAll<HTMLElement>(
      '[data-dt-children-name="ColumnSettingsShowHideColumn"]',
    ),
  );
}

/** Clicks the visibility toggle of the column with the given id within `scope`. */
export function clickVisibilityToggle(
  scope: HTMLElement,
  columnId: string,
): void {
  fireEvent.click(getColumnVisibilityToggle(scope, columnId));
}
